import React, { useState } from 'react';
import { CalendarRange, BellRing, Tag } from 'lucide-react';
import ExercicesComptables from './ExercicesComptables';
import RelancesConfig from './RelancesConfig';
import PlCategoriesConfig from './PlCategoriesConfig';

const TABS = [
  { key: 'exercices',   label: 'Exercices comptables', icon: CalendarRange },
  { key: 'relances',    label: 'Relances',             icon: BellRing },
  { key: 'pl-cats',     label: 'Catégories Pennylane', icon: Tag },
];

export default function Comptabilite() {
  const [tab, setTab] = useState('exercices');

  return (
    <div className="space-y-5">
      {/* En-tête */}
      <div>
        <h1 className="text-lg font-bold" style={{ color: 'var(--text)' }}>Comptabilité</h1>
        <p className="text-sm mt-0.5" style={{ color: 'var(--text-muted)' }}>
          Paramètres et données comptables de votre organisation.
        </p>
      </div>

      {/* Onglets */}
      <div className="flex gap-1 border-b" style={{ borderColor: 'var(--border)' }}>
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            data-testid={`compta-tab-${key}`}
            className="flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition-colors rounded-t-lg"
            style={tab === key
              ? { color: 'var(--primary-solid)', borderBottom: '2px solid var(--primary-solid)', marginBottom: -1 }
              : { color: 'var(--text-muted)' }}
          >
            <Icon size={14} />
            {label}
          </button>
        ))}
      </div>

      {/* Contenu de l'onglet actif */}
      <div className="pt-1">
        {tab === 'exercices' && <ExercicesComptables />}
        {tab === 'relances'  && <RelancesConfig />}
        {tab === 'pl-cats'   && <PlCategoriesConfig />}
      </div>
    </div>
  );
}
